
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
  import GET_POSTINGS from "@/apollo/autocomplete-queries/GetPostings.gql";
  import DropdownOption from "@/entities/DropdownOption";
  import { Query_RootPostingArgs } from "@/generated/graphql";

  @Component({
    components: {
      DropdownFilter,
    },
    apollo: {
      postings: {
        query: GET_POSTINGS,
        variables() {
          return this.postingAutocompleteFilter;
        },
        update(data) {
          return data.posting;
        },
        skip() {
          return !this.postingSearchString;
        },
      },
    },
  })

  export default class PostingsMultiselect extends Vue {
    @Prop({required: true, type: Array}) value!: DropdownOption[];
    @Prop({ type: Object, default: () => {}}) postingsConditions!: Object;
    @Prop({ type: String, default: "Select posting" }) readonly placeholder?: string;
    @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;

    postings: DropdownOption[] = [];
    postingSearchString = "";

    get mappedPostingValue(): String[] {
      return this.value.map((item) => item.name);
    }

    get postingsOptions(): DropdownOption[] {
      if (!this.postings.length) {
        return [];
      }
      return this.postings.map((p: any) => {
        return {
          id: p.id,
          name: p.job_title,
        }
      })
    }
  
    get postingAutocompleteFilter():Query_RootPostingArgs {

      const conditions: any[] = [
        this.postingsConditions,
        { 
          job_title: { 
            _ilike: `%${this.postingSearchString}%` 
          },
        },
      ];

      if (this.mappedPostingValue.length) {
        conditions.push(
          { 
            job_title: { 
              _nin: this.mappedPostingValue
            }, 
          },
        );
      }
      return {
        where: { _and: conditions },
        limit: 5,
      };
    }

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val);
    }
  }
